<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
    >
        <path
            d="M7.41595 12.3759C7.07128 12.1462 6.60564 12.2394 6.37591 12.584C6.14619 12.9287 6.23937 13.3944 6.58405 13.6241C7.68202 14.3559 8.82432 14.7498 10 14.7498C11.1757 14.7498 12.318 14.3559 13.416 13.6241C13.7606 13.3944 13.8538 12.9287 13.6241 12.584C13.3944 12.2394 12.9287 12.1462 12.584 12.3759C11.682 12.9771 10.8243 13.2498 10 13.2498C9.17568 13.2498 8.31798 12.9771 7.41595 12.3759Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.9474 2.216C10.3709 1.84568 9.6309 1.84491 9.05421 2.21626L3.97254 5.48305C2.89876 6.17313 2.25 7.36195 2.25 8.638V14C2.25 16.0712 3.92879 17.75 6 17.75H14.002C16.0732 17.75 17.752 16.0712 17.752 14V8.638C17.752 7.36195 17.1034 6.1732 16.0296 5.48312L10.9474 2.216ZM9.86625 3.47745C9.9475 3.4251 10.0532 3.42443 10.1366 3.47801L15.2184 6.74489C15.8626 7.15882 16.252 7.8721 16.252 8.638V14C16.252 15.2428 15.2448 16.25 14.002 16.25H6C4.75721 16.25 3.75 15.2428 3.75 14V8.638C3.75 7.8721 4.13931 7.15889 4.78346 6.74496L9.86625 3.47745Z"
            fill="currentColor"
        />
    </svg>
</template>
